<template>
    <main class="main publications">
        <router-link v-for="(item, index) in publications.data" :key="item.uid" :to="{ name: 'publication', params: { id: item.uid } }">
            <span class="indent">{{ index + 1 }}</span>{{ item.title }}
            <img v-if="item.preview" class="publication-preview" :style="`top: ${y}px; left: ${x}px`" :src="item.preview.url" alt="cover">
        </router-link>
    </main>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "publications",
    metaInfo() {
        return {
        title: "- Publications"
        };
    },
    data() {
        return {
            x: 0,
            y: 0,
            show: false,
        };
    },
    mounted(){
        window.addEventListener("mousemove", this.handleMouseMove);
    },
    beforeDestroy() {
        window.removeEventListener("mousemove", this.handleMouseMove);
    },
    computed: mapState(["publications"]),
    methods: {
        handleMouseMove(e) {
            this.x = e.clientX;
            this.y = e.clientY;
        }
    }
};
</script>

<style lang="scss" scoped>
.publications {
    display:flex;
    flex-direction: column;
    align-items: start;
    overflow:initial;
}
a {
  display: block;
  position:relative;
  &:hover {
    .publication-preview {
        display: block;
        @media only screen and (max-width: 768px) {
            display: none;
        }
    }
  }
  .publication-preview {
    position:fixed;
    display:none;
    pointer-events: none;
    transform: translate(1rem, 1rem);
    width:15ch;
    z-index:999;
    
  }
}
.indent {
  width: 5rem;
  display: inline-block;
  @media only screen and (max-width: 768px) {
    width: 7rem;
  }
}
</style>
